<div class="page-container">
  <div class="row filter-container">
    <div style="text-align: right;" class="header-funnel me-2" (click)="openFilterModal()">
      Filter
    </div>
  </div>
  <div class="list-container mt-3">
    <app-turnarounds-pair-list [pairList]="pairList" [isFirestore]="true"></app-turnarounds-pair-list>
  </div>
</div>
